import React, { useContext } from "react";
import { TemplateContext } from "../../layout";
import paypalIcon from "/fallbacks/paypal-new.svg";
import { validationSchema } from "../../func/validation.js";

const paypalBtnStyles = window?.post_template?.checkout_v4_global_components;

const PaypalButton = ({
  type,
  text,
  handleClick,
  margin,
  modifications,
  values,
  submitFunc,
  trigger,
  showTermsBox,
  control,
}) => {
  const [templateContext, setTemplateContext] = useContext(TemplateContext);
  const paypalUpper = window.post_template?.checkout_v4_form?.tr_checkout_v4_paypal_upper;
  const paypalBottom = window.post_template?.checkout_v4_form?.tr_checkout_v4_paypal_bottom;

  const paypalStyles = {
    "--paypalBackground": paypalBtnStyles.checkout_v4_components_paypalBackground,
    "--paypalHover": paypalBtnStyles.checkout_v4_components_paypalBackgroundHover,
    "--paypalShadow": paypalBtnStyles.checkout_v4_components_paypalShadowColor,
    "--paypalShadowHover": paypalBtnStyles.checkout_v4_components_paypalShadowColorHover,
    "--paypalTextColor": paypalBtnStyles.checkout_v4_components_paypalTextColor,
    marginTop: margin,
  };

  const handlePaypalSubmit = async (e) => {
    const isChecked = await trigger("policy");

    if (!isChecked && showTermsBox) {
      // Scroll to the policy checkbox
      const policyInput = document.getElementsByName("policy")[0];
      if (policyInput) {
        policyInput.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }

      // Set timeout to clear error
      setTimeout(() => {
        // Clear the error state
        if (control) {
          control.unregister("policy");
          control.register("policy");
        }
      }, 3000);

      return;
    }

    if (templateContext.paypalButtonState === "initial" && templateContext.paypalHandler === "wr") {
      e.preventDefault();

      const firstNameInput = document.getElementById("first_name");
      firstNameInput.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start",
      });

      setTimeout(() => {
        firstNameInput.focus();
        setTemplateContext({
          ...templateContext,
          paymentMethod: "paypal",
          paypalButtonState: "clicked",
        });
      }, 100);
    } else {
      setTemplateContext((prevContext) => ({
        ...prevContext,
        paymentMethod: "paypal",
      }));
      submitFunc(values, { ...templateContext, paymentMethod: "paypal" });
    }
  };

  return (
    <div className={`submitPaypal__wrapper ${modifications?.noBorders ? "submitPaypal__wrapper__noBorders" : ""}`}>
      <div
        className={`submitPaypal__container ${modifications?.noBorders ? "submitPaypal__container__noBorders" : ""}`}
        data-before={paypalUpper}
        data-after={paypalBottom}
      >
        <button
          data-testid="cc-complete-paypal-order"
          onClick={handlePaypalSubmit}
          style={paypalStyles}
          formNoValidate
          type="button"
          className="submitPaypal submitPaypal--active"
        >
          <img src={paypalIcon} className="submitPaypal__paypalLogo" alt="PayPal" />
        </button>
      </div>
    </div>
  );
};

export default PaypalButton;
